import { SectionHairline } from "../../../ui/waq/SectionHairline";
import { faqSection, faqs } from "../../../../content/waq/faq";

/**
 * design/Homepage.dc.html lines 394-422. The white section between two field
 * ones — no background of its own, so the body white shows through.
 *
 * The reference's five questions were rejected by the client as wrong and the
 * section rendered as labelled placeholders until the replacements arrived.
 * Those are now in content/faq.ts — six of them, not the design's five — so the
 * placeholder branch is gone. Read that file before editing this copy: two of
 * the answers make claims the rest of the site does not support, and the notes
 * there say which.
 *
 * Native <details>/<summary>: no client component, and it expands with
 * JavaScript disabled. Answers are paragraphs because the copy is written in
 * them; a single joined string loses the client's own structure.
 */
export function Faq() {
  return (
    <section
      className="mx-auto max-w-container px-section-x pb-section-y"
      aria-labelledby="faq-heading"
    >
      <SectionHairline inset={false} className="mb-section-y" />

      <div className="mb-9 motion-safe:animate-rise">
        <p className="mb-3.5 text-eyebrow font-extrabold uppercase text-blue">
          {faqSection.eyebrow}
        </p>
        <h2 id="faq-heading" className="max-w-[680px] text-h2-light font-extrabold">
          {faqSection.heading}
        </h2>
      </div>

      <div className="grid max-w-[960px] gap-3 motion-safe:animate-rise">
        {faqs.map((faq) => (
          <details
            key={faq.question}
            className="group rounded-card border border-hair bg-surface px-[26px] py-[22px]"
          >
            <summary className="flex cursor-pointer items-center justify-between gap-5 text-faq-q font-extrabold">
              {faq.question}
              {/* The reference shows "+" in both states — inline styles cannot
                  express [open]. Toggling it is the intent. */}
              <span
                aria-hidden="true"
                className="flex-none text-[20px] leading-none text-blue"
              >
                <span className="group-open:hidden">+</span>
                <span className="hidden group-open:inline">−</span>
              </span>
            </summary>

            <div className="mt-3.5 grid max-w-[820px] gap-3.5">
              {faq.answer.map((para) => (
                <p key={para} className="text-body text-soft">
                  {para}
                </p>
              ))}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
